export default "__VITE_ASSET__CsLg0fTd__"